import { render, staticRenderFns } from "./ZDCoaOptionButton.vue?vue&type=template&id=34a29571&"
import script from "./ZDCoaOptionButton.vue?vue&type=script&lang=js&"
export * from "./ZDCoaOptionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports